import React from "react";
import { STATUS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className, size = "sm" }) => {
  const cfg = STATUS[status] || { label: status, icon: null };
  const Icon = cfg.icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap",
        size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm",
        `status-${status}`,
        className
      )}
    >
      {Icon ? <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} /> : null}
      {cfg.label}
    </span>
  );
};
